import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import InfoCard from "../../Cards/InfoCard";

// styles
import * as styles from "./PrecisionCare.module.css";

// images - first section (4 cards)
import memberIcon from "../../../images/forInsurer/member-icn.png";
import medsIcon from "../../../images/forInsurer/meds-icn.png";
import energyIcon from "../../../images/forInsurer/energy-icn.png";
import reverseIcon from "../../../images/forInsurer/reverse-icn.png";

// images - second section (3 cards)
import claimsIcon from "../../../images/forInsurer/claims-icn.png";
import hospIcon from "../../../images/forInsurer/hosp-icn.png";
import costIcon from "../../../images/forInsurer/cost-icn.png";

const propTypes = {
  firstSectionTitle: PropTypes.string,
  firstSectionDescription: PropTypes.string,
  secondSectionTitle: PropTypes.string,
  secondSectionDescription: PropTypes.string,
};

const defaultProps = {
  firstSectionTitle: "Precision Care for Insurance Partners in India",
  firstSectionDescription:
    "Twin Health in India uses AI Digital Twin™ technology to personalize care through real-time insights on nutrition, sleep, and activity — helping restore metabolic balance fast.",
  secondSectionTitle: "Insurers Impact",
};

const PrecisionCare = ({
  firstSectionTitle,
  firstSectionDescription,
  secondSectionTitle,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // First section - 4 cards
  const firstSectionCards = [
    {
      icon: reverseIcon,
      title: "Reverse chronic conditions",
      iconAlt: "Reverse chronic conditions icon",
    },
    {
      icon: medsIcon,
      title: "Cut down on meds",
      iconAlt: "Medication reduction icon",
    },
    {
      icon: hospIcon,
      title: "Avoid hospital stays",
      iconAlt: "Avoid hospital stays icon",
    },
    {
      icon: energyIcon,
      title: "Boost daily energy",
      iconAlt: "Boost daily energy icon",
    },
  ];

  // Second section - 3 cards
  const secondSectionCards = [
    {
      icon: claimsIcon,
      title: "Fewer claims",
      iconAlt: "Claims reduction icon",
    },
    {
      icon: costIcon,
      title: "Lower costs",
      iconAlt: "Cost reduction icon",
    },
    {
      icon: memberIcon,
      title: "Healthier members",
      iconAlt: "Healthier members icon",
    },
  ];

  return (
    <section className={styles.precisionCareWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        {/* First Section - 4 Cards */}
        <div className={styles.section}>
          <div className={styles.headerSection}>
            <h2 className={styles.title}>{firstSectionTitle}</h2>
            <p className={styles.description}>{firstSectionDescription}</p>
            <div className={styles.subHeaderSection}>
              <h2 className={styles.subTitle}>Member's Impact</h2>
            </div>
          </div>

          <div className={styles.cardsSection}>
            <InfoCard
              cards={firstSectionCards}
              backgroundColor="#555A83"
              columns={4}
              iconAlign="center"
            />
          </div>
        </div>

        {/* Second Section - 3 Cards */}
        <div className={styles.section}>
          <div className={styles.headerSection}>
            <h2 className={styles.subTitle}>{secondSectionTitle}</h2>
          </div>

          <div className={styles.subCardsSection}>
            <InfoCard
              cards={secondSectionCards}
              backgroundColor="#555A83"
              columns={3}
              iconAlign="center"
            />
          </div>
          <div className={styles.subHeaderSection}>
            <h3 className={styles.subTitle}>
              Real results. In months, not years.
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

PrecisionCare.propTypes = propTypes;
PrecisionCare.defaultProps = defaultProps;

export default PrecisionCare;
